import * as React from 'react';
import { Avatar, Body1, Label } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import { IDeveloperCell } from '../../../../../../types/newbuildingsCompare';
import { trackCheckDeveloperInfoEvent } from '../tracking';
import { getDeveloperLink } from './getDeveloperLink';
import * as style from './style.css';

export interface IDeveloperCellMobileProps {
  cell: IDeveloperCell;
}

export const DeveloperCellMobile = ({ cell }: IDeveloperCellMobileProps): React.JSX.Element => {
  const developerLink = getDeveloperLink(cell.data?.id);

  return (
    <a className={style['container-mobile']} href={developerLink} onClick={trackCheckDeveloperInfoEvent} target="blank">
      <div className={style['image-wrapper']}>
        <Avatar size={36} src={cell.data?.logoUrl} type="builder" hideBorder />
      </div>
      <div className={style['name']}>
        <Body1>{cell.data?.name}</Body1>
      </div>
      {cell.data?.workSinceText && <Body1>{cell.data.workSinceText}</Body1>}
      {cell.data?.isReliable && (
        <Label
          background="accent-main-secondary"
          color="accent-main-primary"
          rightIcon={<IconFunctionalInformationCircle16 color="current_color" />}
        >
          Надежный
        </Label>
      )}
    </a>
  );
};
